export const formatNumber = (
  number: number,
  options: Intl.NumberFormatOptions = {}
) => {
  return new Intl.NumberFormat("pt-BR", options).format(number);
};

export const formatCurrency = (amount: number) => {
  return formatNumber(amount, {
    style: "currency",
    currency: "BRL",
  });
};
